<template>
  <button
    class="switch-container"
    :class="active ? 'container-active' : 'container-inactive'"
    type="button"
    role="switch"
    :aria-checked="active"
    @click="$emit('toggle')"
  >
    <div class="switch" :class="active ? 'switch-active' : 'switch-inactive'"></div>
  </button>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        active: { type: Boolean, required: true },
    },
});
</script>

<style scoped>
.switch-container {
  transition: 0.2s ease all;
  position: relative;
  width: 48px;
  height: 28px;
  border-radius: 14px;
  border: none;
  cursor: pointer;
  padding: 0;
}
.container-inactive {
  background-color: var(--background-color-disabled);
}
.container-active {
  background-color: var(--radio-inactive);
}
.switch {
  transition: 0.2s ease all;
  position: absolute;
  width: 20px;
  height: 20px;
  top: 4px;
  border-radius: 10px;
}
.switch-active {
  left: 24px;
  background-color: var(--radio);
}
.switch-inactive {
  left: 4px;
  background-color: var(--white);
}
</style>
